import Model from "../models/model";
import {InstanceHelper} from "./instanceHelper";

export let ModelHelper = {
  getId<T extends Model>(instance: string | T): string {
    if (InstanceHelper.isString(instance)) {
      return instance;
    } else {
      return instance.id;
    }
  },
  getClientId<T extends Model>(instance: string | T): string {
    if (InstanceHelper.isString(instance)) {
      return instance;
    } else {
      return instance.client_id;
    }
  }
};
